import React from 'react';
import * as S from './styles';

interface SelectBoxProps {
  options: { label: string; value: string }[];
  value?: string;
  name: string;
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  placeholder?: string;
  extraText?: string;
}

const SelectBox: React.FC<SelectBoxProps> = ({ options, value, name, onChange, placeholder, extraText, ...props }) => {
  return (
    <S.SelectContainer>
      <S.StyledSelect name={name} value={value && value} onChange={onChange} {...props}>
        {/* {placeholder && <option value="">{placeholder}</option>} */}
        {options.map((option, index) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </S.StyledSelect>
      {extraText && <S.ExtraText>{extraText}</S.ExtraText>}
    </S.SelectContainer>
  );
};

export default SelectBox;
